/**
 * Dev mode switcher.
 *
 * The mode is stored in the `twk-dev-mode` cookie and read in PHP (twk_is_dev_mode() in lib/load-assets.php),
 * which then serves the `--dev` CSS and JS files. The button (lib/dev-mode.php) is only rendered for logged-in users.
 */
function devMode() {
	const devModeButton = document.querySelector('[data-name="dev-mode-button"]');
	if ( ! devModeButton ) return;

	const devModeStatus = document.querySelector('[data-name="dev-mode-status"]');
	const isDevMode     = window.php_vars?.isDevMode === true;

	if ( devModeStatus ) {
		devModeStatus.innerText = isDevMode ? 'ON' : 'OFF';
	}

	devModeButton.addEventListener('click', function() {
		const secure = window.location.protocol === 'https:' ? '; Secure' : '';
		const oneYear = 60 * 60 * 24 * 365;

		document.cookie = `twk-dev-mode=${ isDevMode ? 'false' : 'true' }; path=/; max-age=${ oneYear }; SameSite=Lax${ secure }`;
		window.location.reload();
	});
}
export default devMode;
